// Focus util functions from:
// https://www.w3.org/TR/wai-aria-practices/examples/dialog-modal/dialog.html

const isFocusable = (element) => {
  if (
    element.tabIndex > 0 ||
    (element.tabIndex === 0 && element.getAttribute("tabIndex") !== null)
  ) {
    return true;
  }

  if (element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case "A":
      return !!element.href && element.rel !== "ignore";
    case "INPUT":
      return element.type !== "hidden" && element.type !== "file";
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return true;
    default:
      return false;
  }
};

/**
 * @desc Set Attempt to set focus on the current node.
 * @param element The node to attempt to focus on.
 * @returns true if element is focused.
 */
const attemptFocus = (element) => {
  if (!isFocusable(element)) {
    return false;
  }
  try {
    element.focus();
  } catch (e) {
    // ignore
  }
  return document.activeElement === element;
};

/**
 * @desc Set focus on descendant nodes until the first focusable element is
 *       found.
 * @param element DOM node for which to find the first focusable descendant.
 * @returns true if a focusable element is found and focus is set.
 */
export const focusFirstDescendant = (element) => {
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < element.childNodes.length; i++) {
    const child = element.childNodes[i];
    if (attemptFocus(child) || focusFirstDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Find the last descendant node that is focusable.
 * @param element DOM node for which to find the last focusable descendant.
 * @returns true if a focusable element is found and focus is set.
 */
export const focusLastDescendant = (element) => {
  // eslint-disable-next-line no-plusplus
  for (let i = element.childNodes.length - 1; i >= 0; i--) {
    const child = element.childNodes[i];
    if (attemptFocus(child) || focusLastDescendant(child)) {
      return true;
    }
  }
  return false;
};
try {
    // @ts-ignore
    focusFirstDescendant.displayName = "focusFirstDescendant";
    // @ts-ignore
    focusFirstDescendant.__docgenInfo = { "description": "", "displayName": "focusFirstDescendant", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/Modal/focusUtils.ts#focusFirstDescendant"] = { docgenInfo: focusFirstDescendant.__docgenInfo, name: "focusFirstDescendant", path: "src/shared/hoc/Modal/focusUtils.ts#focusFirstDescendant" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    focusLastDescendant.displayName = "focusLastDescendant";
    // @ts-ignore
    focusLastDescendant.__docgenInfo = { "description": "", "displayName": "focusLastDescendant", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/Modal/focusUtils.ts#focusLastDescendant"] = { docgenInfo: focusLastDescendant.__docgenInfo, name: "focusLastDescendant", path: "src/shared/hoc/Modal/focusUtils.ts#focusLastDescendant" };
}
catch (__react_docgen_typescript_loader_error) { }